






























































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import {
  ADMIN_SIDEBAR_OPTIONS,
  MANAGE_SPACE_OPTIONS,
  MANAGE_SPACE_SIDEBAR,
  MANAGE_SPACE_SIDEBAR_INVITE,
  MANAGE_TYPE_OPTIONS,
  MANAGE_SPACE_IN_SUPER_SPACE_SIDEBAR,
} from "@/resources/constants/sidebarMenu";
import ModalAddSpaceComponent from "@/app/components/manageSpace/components/superSpace/modalAddSpace.component.vue";
import ManageUsersComponent from "@/app/components/manageSpace/components/users/manageUsers.component.vue";
import CustomizeSpaceComponent from "@/app/components/manageSpace/components/space/customizeSpace/customizeSpace.component.vue";
import UpdateRoomsComponent from "@/app/components/manageSpace/components/space/updateRooms/updateRooms.component.vue";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import InviteUsersComponent from "@/app/components/manageSpace/components/users/inviteUsers/inviteUsers.component.vue";
import SpaceSettingsComponent from "@/app/components/manageSpace/components/space/spaceSettings/spaceSettings.component.vue";
import DashboardComponent from "@/app/admin/components/dashboard/dashboard.component.vue";
import CustomizeSuperSpaceComponent from "@/app/components/manageSpace/components/superSpace/customizeSuperSpace.component.vue";
import ConfigurationSuperSpaceComponent from "@/app/components/manageSpace/components/superSpace/configurationSuperSpace.component.vue";
import SettingSuperSpaceComponent from "@/app/components/manageSpace/components/superSpace/settingsSuperSpace.component.vue";
import DashboardSuperComponent from "@/app/components/manageSpace/components/superSpace/dashboardSuper.component.vue";
import ManageSuperSpaceUsersComponent from "./components/superSpace/manageSuperSpaceUsers.component.vue";
import ManageLogsComponent from "./components/users/manageLogs.component.vue";
import AnnouncementsComponent from "./announcements/announcements.component.vue";
import { i18n } from "@/resources/locales";
import UpdatePosterComponent from "./components/space/updatePoster/updatePoster.component.vue";
import GroupUsersComponent from "./components/users/groupUsers.component.vue";
import { PLAN } from "@/resources/constants/plan";
import Plans from "@/resources/mixins/plans/plans";
@Component({
  name: "manage-space-component",
  components: {
    SpaceSettingsComponent,
    InviteUsersComponent,
    UpdateRoomsComponent,
    CustomizeSpaceComponent,
    ManageUsersComponent,
    DashboardComponent,
    CustomizeSuperSpaceComponent,
    SettingSuperSpaceComponent,
    DashboardSuperComponent,
    ManageSuperSpaceUsersComponent,
    ManageLogsComponent,
    ModalAddSpaceComponent,
    AnnouncementsComponent,
    UpdatePosterComponent,
    ConfigurationSuperSpaceComponent,
    GroupUsersComponent,
  },
})
export default class ManageSpaceComponent extends mixins(UserValidator, Plans) {
  spaceSelected = null;
  sidebarMenu =
    this.isAdmin() || this.isSuperSpaceOwner()
      ? MANAGE_SPACE_SIDEBAR
      : MANAGE_SPACE_SIDEBAR_INVITE;
  sidebarMenuSpaceInSuperSpace = MANAGE_SPACE_IN_SUPER_SPACE_SIDEBAR;
  MANAGE_SPACE_OPTIONS = MANAGE_SPACE_OPTIONS;
  ADMIN_SIDEBAR_OPTIONS = ADMIN_SIDEBAR_OPTIONS;
  MANAGE_TYPE_OPTIONS = MANAGE_TYPE_OPTIONS;
  openModal = false;
  index1 = 0;
  index2 = 0;
  index3 = 5;
  index4 = 5;
  owner = null;
  loader = false;
  PLAN = PLAN;
  activeAddSpace = false;
  mounted(): void {
    this.lengthEnabledBySuperAdmin(this.getMaxSpaces());
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.owner = this.isSuperSpaceOwner();
    this.sidebarMenu =
      this.isAdmin() || this.isSuperSpaceOwner()
        ? [...MANAGE_SPACE_SIDEBAR]
        : [...MANAGE_SPACE_SIDEBAR_INVITE];
    if (
      !this.owner ||
      (this.isSuperAdmin() &&
        this.manageModalType === MANAGE_TYPE_OPTIONS.SPACE)
    ) {
      for (let index = 0; index < this.sidebarMenu.length; index++) {
        const element = this.sidebarMenu[index];
        if (
          element.id == MANAGE_SPACE_OPTIONS.MULTI_SPACE_CUSTOMIZE ||
          element.id == MANAGE_SPACE_OPTIONS.MULTI_SPACE_CONFIGURATION ||
          element.id == MANAGE_SPACE_OPTIONS.MULTI_SPACE_SETTING ||
          element.id == ADMIN_SIDEBAR_OPTIONS.DASHBOARD_SP ||
          element.id == ADMIN_SIDEBAR_OPTIONS.USERS_SP ||
          element.id == ADMIN_SIDEBAR_OPTIONS.USERS_GROUP
        ) {
          this.sidebarMenu.splice(index, 1);
          index--;
        }
        if (element.id == ADMIN_SIDEBAR_OPTIONS.ANNOUNCEMENTS) {
          element.label = i18n.t("buttons.programNotification");
        }
      }
      this.index1 = -1;
      this.index3 = 5;
      this.index4 = 8;
    } else {
      for (let index = 0; index < this.sidebarMenu.length; index++) {
        const element = this.sidebarMenu[index];
        if (
          element.id == MANAGE_SPACE_OPTIONS.MULTI_SPACE_SETTING ||
          element.id == MANAGE_SPACE_OPTIONS.MANAGE ||
          element.id == MANAGE_SPACE_OPTIONS.ROOMS ||
          element.id == MANAGE_SPACE_OPTIONS.POSTERS ||
          element.id == ADMIN_SIDEBAR_OPTIONS.DASHBOARD ||
          element.id == MANAGE_SPACE_OPTIONS.SETTINGS ||
          element.id == MANAGE_SPACE_OPTIONS.CUSTOMIZE ||
          element.id == MANAGE_SPACE_OPTIONS.INVITE
        ) {
          this.sidebarMenu.splice(index, 1);
          index--;
        }
        if (element.id == ADMIN_SIDEBAR_OPTIONS.ANNOUNCEMENTS) {
          element.label = i18n.t("buttons.programNotification");
        }
      }
      this.index1 = 0;
      this.index2 = 8;
      this.index3 = 3;
    }
  }
  get disabledLoader(): boolean {
    const lastPage = this.$store.getters["SpaceStore/getLastPageSpaces"];
    const page = this.$store.getters["SpaceStore/getSpacesAvailablePage"];
    return page > lastPage;
  }
  get manageModalType() {
    return this.$store.getters["SystemStore/getManageModalType"];
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  /*get space(): any {
    return this.$store.getters["SpaceStore/getSpace"];
  }*/
  get selectedSpaceCustomize(): any {
    return this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
  }
  get spaceAvailable(): any {
    return this.$store.getters["SpaceStore/getSpacesAvailable"];
  }
  get menuActive(): string {
    return this.$store.getters["SystemStore/getManageSpaceMenuActive"];
  }
  set menuActive(e: string) {
    if (!isNaN(Number(e))) this.selectSpace(e);
    if (e === "new-space") this.openModal = true;
    this.$store.dispatch("SystemStore/setManageSpaceMenuActiveAction", e);
  }
  get active(): boolean {
    return this.$store.getters["FloatMenuStore/getManageSpace"];
  }
  set active(e: boolean) {
    this.$store.dispatch("FloatMenuStore/setManageSpaceAction", e);
  }
  getLabel() {
    let label = null;
    if (this.spaceSelected === null) {
      this.sidebarMenu.forEach((element) => {
        if (element.id === this.menuActive) {
          label = element.label;
        }
      });
    } else {
      this.sidebarMenuSpaceInSuperSpace.forEach((element) => {
        if (element.id === this.menuActive) {
          label = element.label;
        }
      });
    }
    return label;
  }
  async getSpaces(): Promise<void> {
    this.loader = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    let id;
    if (this.isSuperAdmin()) id = this.superSpace.id;
    else id = space ? space.superSpace.id : this.superSpace.id;
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: id,
      callback: (response) => {
        this.loader = false;
      },
      callbackError: (error) => {
        this.loader = false;
      },
    });
  }
  selectSpace(spaceId) {
    this.spaceSelected = spaceId;
    this.$store.dispatch("SpaceStore/getSpaceAction", {
      spaceId,
      callback: (response) => {
        this.$store.dispatch(
          "SpaceStore/setSelectedSpaceCustomizeAction",
          response
        );
        this.$store.dispatch(
          "SystemStore/setManageSpaceMenuActiveAction",
          MANAGE_SPACE_OPTIONS.CUSTOMIZE
        );
      },
      callbackError: (error) => {
        console.log("TTT KO ManageSpaceComponent selectSpace ", error);
      },
    });
  }
  goBack() {
    this.spaceSelected = null;
    this.$store.dispatch(
      "SystemStore/setManageSpaceMenuActiveAction",
      MANAGE_SPACE_OPTIONS.MULTI_SPACE_CUSTOMIZE
    );
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.getSpaces();
  }
  lengthEnabledBySuperAdmin(getMaxSpaces: number) {
    let count = 0;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getAllSpacesAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      callback: (response) => {
        response.data.forEach(async (element) => {
          if (element.enabledBySuperAdmin == true) {
            await count++;
          }
        });
        if (getMaxSpaces > count)
          this.activeAddSpace = false;
        else {
          this.activeAddSpace = true;
        }  
      },
      callbackError: (error) => {
        console.log("TTT lengthEnabledBySuperAdmin ERROR ", error);
        this.activeAddSpace = false;
      },
    });
  }
}
